import * as IconSelector from '../icons';

export const archivo = [
    {
        value: 'Archivado',
        label: 'Archivado',
        description: 'Elemento Archivado',
        icon: IconSelector.ArchiveIcon,
        color: 'Black'
    },
    {
        value: 'Disponible',
        label: 'Disponible',
        description: 'Elemento no Archivado',
        icon: IconSelector.UnarchiveIcon,
        color: 'Green'
    }
];
